import { Controller } from "@hotwired/stimulus"

// The "post your letter" drop-zone on the Mailbox page: click or drag-drop a
// photo of a letter and preview it in place. (Front-end only — wiring it to a
// real upload/Active Storage is a future step.)
export default class extends Controller {
  static targets = [ "input", "preview", "dropzone", "status", "actions", "postButton", "log" ]

  connect() {
    this.storageKey = "magicSheepSparklePost"
    this.objectUrl = null
    this.currentFile = null
    this.renderLog()
  }

  pickPhoto() {
    const input = this.hasInputTarget ? this.inputTarget : this.element.querySelector("[data-ms-file]")
    input?.click()
  }

  select(e) { this.fileChosen(e) }

  fileChosen(e) {
    const file = e.target.files && e.target.files[0]
    if (file) this.preview(file)
  }

  dragOver(e) { e.preventDefault(); e.currentTarget.style.background = "#F4E8C8" }
  dragLeave(e) { e.currentTarget.style.background = "#FFFDF6" }

  dropPhoto(e) {
    e.preventDefault()
    e.currentTarget.style.background = "#FFFDF6"
    const file = e.dataTransfer?.files && e.dataTransfer.files[0]
    if (file) this.preview(file)
  }

  preview(file) {
    const img = this.hasPreviewTarget ? this.previewTarget : this.element.querySelector("[data-ms-drop-preview]")
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)

    this.currentFile = file
    this.objectUrl = URL.createObjectURL(file)
    img.src = this.objectUrl
    img.style.display = "block"

    if (this.hasActionsTarget) this.actionsTarget.hidden = false
    if (this.hasPostButtonTarget) this.postButtonTarget.disabled = false
    this.setStatus(`${file.name} is tucked into the reply hatch. Ready for Sparkle Post.`)
  }

  post() {
    if (!this.currentFile) {
      this.setStatus("Ada cannot find the picture yet. Try choosing one first.")
      return
    }

    const sent = this.loadSent()
    sent.unshift({
      name: this.currentFile.name,
      type: this.currentFile.type || "mystery evidence",
      sentAt: new Date().toISOString()
    })
    window.localStorage.setItem(this.storageKey, JSON.stringify(sent.slice(0, 4)))

    this.dropzoneTarget?.classList.add("ms-upload-drop--posted")
    if (this.hasPostButtonTarget) this.postButtonTarget.disabled = true
    this.setStatus("Your note has been folded into a tiny woolly envelope and sent to Ada. She may need some time to read it because hooves.")
    this.renderLog()
  }

  reset() {
    this.currentFile = null
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
    if (this.hasInputTarget) this.inputTarget.value = ""
    if (this.hasPreviewTarget) {
      this.previewTarget.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
      this.previewTarget.style.display = "none"
    }
    if (this.hasActionsTarget) this.actionsTarget.hidden = true
    this.dropzoneTarget?.classList.remove("ms-upload-drop--posted")
    this.setStatus("Ada is ready with a tiny woolly envelope.")
  }

  renderLog() {
    if (!this.hasLogTarget) return

    const sent = this.loadSent()
    if (sent.length === 0) {
      this.logTarget.innerHTML = `
        <strong>Recently Sent By Sparkle Post</strong>
        <small>Notes posted from this browser will appear here so Ada can check them slowly, with hooves.</small>
      `
      return
    }

    const items = sent.map((note) => {
      const sentAt = new Date(note.sentAt).toLocaleString([], { dateStyle: "medium", timeStyle: "short" })
      return `<li><span>✉️</span><strong>${this.escape(note.name)}</strong><small>${sentAt}</small></li>`
    }).join("")

    this.logTarget.innerHTML = `
      <strong>Recently Sent By Sparkle Post</strong>
      <ul>${items}</ul>
    `
  }

  loadSent() {
    try {
      return JSON.parse(window.localStorage.getItem(this.storageKey) || "[]")
    } catch {
      return []
    }
  }

  setStatus(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }

  escape(value) {
    const node = document.createElement("span")
    node.textContent = value
    return node.innerHTML
  }
}
